<template>
  <v-container fluid class="elevation-1">
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "jefecomunidad-home",
  data() {
    return {
      drawer: true,
      mini: true,
      items: [
        {
          title: this.$t("formulate.sources"),
          icon: "mdi-alpha-f-circle",
          to: "/jefecomunidads/sources",
        },
        {
          title: this.$t("formulate.entry"),
          icon: "mdi-alpha-i-box",
          to: "/jefecomunidads/entry",
        },
        {
          title: this.$t("formulate.expenses"),
          icon: "mdi-alpha-e-circle",
          to: "/jefecomunidads/expenses",
        },
      ],
    }
  },
}
</script>
